import { SortObject, SortModeEnum } from 'components/filtering/types/SortObject';
import { FilterObject, FilterValue } from 'components/filtering/types/FilterObject';
import BaseGridHeader from 'components/filtering/base-grid-header/BaseGridHeader';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';
import { headersObject } from '@pages/reporting-pages/deliveries-sku/headersObject';



interface GridHeaderProps<T> {
	sortObject?: SortObject<T> | null,
	filterObject?: FilterObject<T> | null,
	onSearchValues?: (property: keyof T, checkedValues: unknown[]) => void,
	onAddFilterValues?: (property: keyof T, showedFilterValues: FilterValue[]) => void,
	onClearFilter?: (property: keyof T) => void,
	onSorting?: (property: keyof T, mode: SortModeEnum) => void,
	onClearSorting?: (property: keyof T) => void,
}


const GridHeader = (props: GridHeaderProps<SkuReportGridData>) => {
	const { sortObject, filterObject, onSearchValues, onAddFilterValues, onClearFilter, onSorting, onClearSorting } = props;

	return (
		<>
			{headersObject.map(x =>
				<BaseGridHeader
					label={x.label}
					propertyName={x.key as never}
					sortObject={sortObject as any}
					filterObject={filterObject as any}
					onSearchValues={onSearchValues as any}
					onAddFilterValues={onAddFilterValues as any}
					onClearFilter={onClearFilter as any}
					onSorting={onSorting as any}
					onClearSorting={onClearSorting as any}
					key={`base-grid-header-${x.label}`} />)}
		</>
	)
}

export default GridHeader;